import { render, staticRenderFns } from "./tagPanel.vue?vue&type=template&id=32f709e8&scoped=true&"
import script from "./tagPanel.vue?vue&type=script&lang=js&"
export * from "./tagPanel.vue?vue&type=script&lang=js&"
import style0 from "./tagPanel.vue?vue&type=style&index=0&id=32f709e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f709e8",
  null
  
)

export default component.exports